const { EndPoints } = require("settings/endpoints");
const { default: axiosInstance } = require("./axios");
const zone_id = Number(localStorage.getItem("zone_id"));

export const fetchPanelMaster = (
  page_no,
  filter
  // limit = DEFAULT_TOTAL_RECORDS
) => {
  const f_is_franchise_employee = Number(
    localStorage.getItem("is_franchise_employee")
  );
  const f_franchise_id = Number(localStorage.getItem("franchise_id"));
  const f_is_super_franchise = Number(
    localStorage.getItem("is_super_franchise")
  );

  let params = {
    // limit,
    page_no,
    zone_id,
    ...filter,
  };

  params = {
    ...params,
    f_is_franchise_employee,
    f_franchise_id,
    f_is_super_franchise,
  };

  return axiosInstance.get(EndPoints.PANELMASTER.LIST, {
    params,
  });
};

export const fetchLimsFranchiseCopyRates = (
  page_no,
  filter
  // limit = DEFAULT_TOTAL_RECORDS
) => {
  const f_is_franchise_employee = Number(
    localStorage.getItem("is_franchise_employee")
  );
  const f_franchise_id = Number(localStorage.getItem("franchise_id"));
  const f_is_super_franchise = Number(
    localStorage.getItem("is_super_franchise")
  );

  let params = {
    // limit,
    page_no,
    zone_id,
    ...filter,
  };

  params = {
    ...params,
    f_is_franchise_employee,
    f_franchise_id,
    f_is_super_franchise,
  };

  return axiosInstance.get(
    EndPoints.PANELMASTER.LIMS_FRANCHISE_COPY_RATE_LIST,
    {
      params,
    }
  );
};

export const updateLimsFranchiseCopyRates = (payload) => {
  return axiosInstance.put(EndPoints.PANELMASTER.LIMS_UPDATE, payload, {
    params: {
      f_is_franchise_employee: Number(localStorage.getItem("is_franchise_employee")),
      f_franchise_id: Number(localStorage.getItem("franchise_id")),
      f_is_super_franchise: Number(localStorage.getItem("is_super_franchise")),
    },
  });
};

export const fetchPanelMasterPending = (payload) => {
  const params = new URLSearchParams();

  if (payload?.franchise_id !== undefined) {
    params.append("franchise_id", payload.franchise_id);
  }

  if (payload?.investigation_id !== undefined) {
    params.append("investigation_id", payload.investigation_id);
  }

  return axiosInstance.get(
    `${EndPoints.PANELMASTER.PENDING_LIST}?${params.toString()}`
  );
};

export const createTestRate = (payload) => {
  return axiosInstance.post(EndPoints.TESTRATE.CREATE, payload);
};

export const updatePanelMaster = (payload) => {
  return axiosInstance.put(EndPoints.PANELMASTER.UPDATE, payload);
};

export const updatePanelMasterSync = (payload) => {
  return axiosInstance.put(EndPoints.PANELMASTER.SYNC, payload);
};

export const deleteTestRate = (payload) => {
  const url = EndPoints.TESTRATE.DELETE + `/${payload}`;
  return axiosInstance.delete(url);
};

export const downloadCSV = () => {
  return axiosInstance.put(EndPoints.TESTRATE.DOWNLOAD_CSV, {
    responseType: "blob",
  });
};

export const createCopyRates = (payload) => {
  // return "need to fix the API first";
  return axiosInstance.post(EndPoints.TESTRATE.COPY_RATES, payload);
};

export const franchiseInvestigationDetails = (
  franchise_id = null,
  investigation_id = null
) => {
  const params = {};

  if (franchise_id !== null) {
    params.franchise_id = franchise_id;
  }
  if (investigation_id !== null) {
    params.investigation_id = investigation_id;
  }

  return axiosInstance.get(
    EndPoints.PANELMASTER.FRANCHISE_INVESTIGATION_DETAILS,
    { params }
  );
};
